import axios from "axios";

const PreferenceService = {
  constructor() {
    this.site = {};
    this.map = {};
  },

  setEndpoints(endpoint, endpointRefresh){
    this.endpoint = endpoint+'/api/v3';
    this.endpointRefresh = endpointRefresh;
  },

  getPreference(callback) {
    axios.get(this.endpoint + "/config").then(response => {
      if (
        response.data &&
        response.data.results &&
        response.data.results.length >= 3
      ) {
        callback(response.data.results);
      }
    });
  },

  getUser(token, callback) {
    axios
      .get(this.endpoint + "/users/me", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        if (callback) {
          callback(response);
        }
      });
  },

  query(token, path) {
    return axios
      .get(this.endpointRefresh + path, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
  },

  getSite() {
    return this.site;
  },

  getMap() {
    return this.map;
  }
};

export { PreferenceService };
